import { ALL_ONBOARDING_PAID_SCOPES } from 'onboarding-scopes/scopeConstants';
import { ONBOARDING_SCOPES_TO_TRIAL_SCOPES } from './trialScopes';
const isOnboardingScope = scope => ALL_ONBOARDING_PAID_SCOPES.includes(scope);
export const isOwned = (allScopes, scopeToCheck) => {
  if (isOnboardingScope(scopeToCheck) && allScopes.length > 0) {
    const trialScope = ONBOARDING_SCOPES_TO_TRIAL_SCOPES[scopeToCheck];
    return allScopes.includes(scopeToCheck) && (!trialScope || !allScopes.includes(trialScope));
  }
  return false;
};
export const ownsAll = (allScopes, candidateScopes) => {
  return candidateScopes.every(scopeToCheck => isOwned(allScopes, scopeToCheck));
};
export const ownsNone = (allScopes, candidateScopes) => {
  return candidateScopes.every(scopeToCheck => !isOwned(allScopes, scopeToCheck));
};
export const ownsAny = (allScopes, candidateScopes) => {
  return candidateScopes.some(scopeToCheck => isOwned(allScopes, scopeToCheck));
};